/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Resting_HrInputs */

const en_ui_thresholds_resting_hr = /** @type {(inputs: Ui_Thresholds_Resting_HrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resting HR (bpm)`)
};

const de_ui_thresholds_resting_hr = /** @type {(inputs: Ui_Thresholds_Resting_HrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruhe-HF (bpm)`)
};

/**
* | output |
* | --- |
* | "Resting HR (bpm)" |
*
* @param {Ui_Thresholds_Resting_HrInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_resting_hr = /** @type {((inputs?: Ui_Thresholds_Resting_HrInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Resting_HrInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_resting_hr(inputs)
	return de_ui_thresholds_resting_hr(inputs)
});